require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-a-le-coq-limpa-tvc.json") })
        }
      }, "path---projects-a-le-coq-limpa-tvc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-a-le-coq-limpa-tvc!./.cache/json/projects-a-le-coq-limpa-tvc.json
// module id = 588
// module chunks = 231608221292675